//获取本地数据
function getData(dataName) {
  // localStorge为window内置属性，用于在浏览器存储本地信息
  // 该数据除非手动删除，否则会一直存在
  // let data = localStorage.getItem("todoList") //取值
  let data = localStorage.getItem(dataName) //取值
  if (data !== null) {
    //ES6将变量作为键→[变量名]
    // return JSON.parse(data).[dataName] //将数据转换为json
    return JSON.parse(data)
  } else {
    return []
  }
}

//保存本地数据
function saveData(data, dataName) {
  //JSON.stringify()将json数据转换为字符串
  localStorage.setItem(dataName, JSON.stringify(data)) //设值    
}

//删除数据
function deleteData(index, dataName) {
  //获取本地数据
  let data = getData(dataName)
  // let index = index //获取索引号
  //改本地数据（删除数据）
  data.splice(index, 1)
  //保存本地数据
  saveData(data)
}

//渲染加载数据
function load() {

}

//获取当前时间函数
let getDateStr = function() {
  var dd = new Date()
  var y = dd.getFullYear()  
  var m = dd.getMonth() + 1 //获取当前月份的日期
  if (m < 10) {
    m = '0' + m
  }
  var d = dd.getDate()
  if (d < 10) {
    d = '0' + d
  }
  return y + "-" + m + "-" + d
}


export {
  getData,
  saveData,
  deleteData,
  getDateStr
}